import React from 'react'
import { TextContainer, Image, DisplayText, Markdown, ErrorText } from '../components'
import styles from 'assets/scss/views/Auth.scss'
import defaultPropertyImage from './../assets/images/defaultPropertyImage.png'
import * as translationService from '../services/translationService'
import { propTypes } from 'react-svg-spinner'

export const PropertyNotFoundView = props => {
  let errorMessage = undefined
  if (props.error) {
    try {
      errorMessage = props.error.message
    } catch (error) {
      errorMessage = 'Could not parse error message'
    }
  }

  return (
    <div className={styles.Auth}>
      <div className={styles.Text}>
        <TextContainer>
          <DisplayText>{translationService.t('tenant_profile.property_not_found.title')}</DisplayText>
          <Markdown source={translationService.t('tenant_profile.property_not_found.info')} />

          {errorMessage && <ErrorText>{`Error ref.: ${errorMessage}`}</ErrorText>}
        </TextContainer>
      </div>
      <div className={styles.Image}>
        <Image source={defaultPropertyImage} />
      </div>
    </div>
  )
}

PropertyNotFoundView.propTypes = {
  error: propTypes.object,
}

export default PropertyNotFoundView



// WEBPACK FOOTER //
// ./src/views/PropertyNotFoundView.js